<input type="text" class="form-control mb-2" placeholder="Insert short title here" formControlName="title" />
<hr />
<select class="form-control" formControlName="contextType">
    <option [value]="ContextInfoCustomFormType.BUILDING">Building</option>
    <option [value]="ContextInfoCustomFormType.EVALUATOR">Supervisor Name</option>
    <option [value]="ContextInfoCustomFormType.TARGET">Employee Name</option>
    <option [value]="ContextInfoCustomFormType.START_DATE">Start Date</option>
    <option [value]="ContextInfoCustomFormType.COMPLETED_DATE">Completed Date</option>
</select>

